import { useNavigateWithSearch } from "hooks/useNavigateWithSearch";
import AccordionTemplate from "components/accordions/accordion-template/AccordionTemplate";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";
import { useContactInformation } from "hooks/useContactInformation";
import { ROUTES, CARD_FRAGMENTS } from "routes/constants";

const SecondaryAddresseeAccordion = () => {
    const navigate = useNavigateWithSearch();
    const { contactData } = useContactInformation();

    const secondaryAddresseeData = contactData?.secondaryAddressee;

    const handleEdit = () => {
        pushGTMEvent(GA_EVENT_CONFIGS.REVIEW_EDIT_SECONDARY);
        navigate(`${ROUTES.APPLICATION.CONTACT}${CARD_FRAGMENTS.SECONDARY_ADDRESSEE}`);
    };

    return (
        <AccordionTemplate
            title="Secondary Addressee"
            accordionName="your-review-information"
            onEdit={handleEdit}
            dataTestId="secondary-addressee-accordion"
        >
            <div className="flex flex-col gap-1 mb-4">
                <p className="text-base-content text-sm font-semibold">Do you wish to designate a secondary addressee?</p>
                <p className="text-base-content text-sm font-medium">
                    {secondaryAddresseeData?.hasSecondaryAddressee ? "Yes" : "No"}
                </p>
            </div>
            {secondaryAddresseeData?.hasSecondaryAddressee && (
                <>
                    <div className="flex flex-col gap-1 mb-4">
                        <p className="text-base-content text-sm font-semibold">Name</p>
                        <p className="text-base-content text-sm font-medium blur-upscope">
                            {secondaryAddresseeData?.firstName} {secondaryAddresseeData?.lastName}
                        </p>
                    </div>
                    <div className="flex flex-col gap-1 mb-4">
                        <p className="text-base-content text-sm font-semibold">Phone Number</p>
                        <p className="text-base-content text-sm font-medium blur-upscope">{secondaryAddresseeData?.phone}</p>
                    </div>
                    <div className="flex flex-col gap-1 mb-4">
                        <p className="text-base-content text-sm font-semibold">Street Address</p>
                        <p className="text-base-content text-sm font-medium blur-upscope">{secondaryAddresseeData?.address}</p>
                        <p className="text-base-content text-sm font-medium blur-upscope">
                            {secondaryAddresseeData?.city}, {secondaryAddresseeData?.state}, {secondaryAddresseeData?.zipCode}
                        </p>
                    </div>
                </>
            )}
        </AccordionTemplate>
    );
};

export default SecondaryAddresseeAccordion;
